import { ApolloQueryResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface CustomerOrdersQueryObject {
  customerOrders: {
    items: {
      increment_id: boolean
      id: boolean
      created_at: boolean
      grand_total: boolean
      status: boolean
      order_items: {
        sku: boolean
        price: boolean
        qty: boolean
        thumbnail: boolean
        name: boolean
        item_base_price: boolean
        item_discount: boolean
        options: {
          label: boolean
          value: boolean
        }
      }
      visiture_order_history: {
        discount: boolean
        subtotal: boolean
        tax: boolean
        shipping_amount: boolean
        shipping_method: boolean
      }
    }
  }
}

export const customerOrdersQueryObject: CustomerOrdersQueryObject = {
  customerOrders: {
    items: {
      increment_id: true,
      id: true,
      created_at: true,
      grand_total: true,
      status: true,
      order_items: {
        sku: true,
        price: true,
        qty: true,
        thumbnail: true,
        name: true,
        item_base_price: true,
        item_discount: true,
        options: {
          label: true,
          value: true
        }
      },
      visiture_order_history: {
        discount: true,
        subtotal: true,
        tax: true,
        shipping_amount: true,
        shipping_method: true
      }
    }
  }
}

export type GetCustomerOrdersQuery = () => Promise<ApolloQueryResult<any>>

export const createCustomerOrdersQuery = ({ getQueries }: ServiceDependencies): GetCustomerOrdersQuery => async () => {
  const query = getQueries().customerOrdersQuery

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`,
    fetchPolicy: 'no-cache'
  })
}
